import { useEffect } from "react";

import { useCookieConsent } from "@/hooks/useCookieConsent";
import { useAdsConversionSharingCountry } from "@/lib/adsConversionSharing";
import { isMetaAdsRolloutCountry, setMetaAdsMeasurementState } from "@/lib/metaAdsMeasurement";

export function MetaAdsTag({ pixelId, countryCode }: { pixelId: string; countryCode?: string }) {
  const {
    globalPrivacyControl,
    isAuthenticated,
    isConsentRequired,
    isConsentResolved,
    marketingConsent,
    marketingConsentEnabled,
  } = useCookieConsent();
  const isRolloutCountry = isMetaAdsRolloutCountry(countryCode);
  const shouldShareAllConversions = useAdsConversionSharingCountry("meta", countryCode);
  const isAwaitingRequiredMarketingDecision =
    !isAuthenticated &&
    isConsentRequired === true &&
    marketingConsent == null &&
    !globalPrivacyControl;
  const canEnableMeasurement =
    isRolloutCountry &&
    isConsentResolved &&
    (isAuthenticated || isConsentRequired !== undefined) &&
    !isAwaitingRequiredMarketingDecision;
  const measurementEnabled = canEnableMeasurement && marketingConsentEnabled && Boolean(pixelId);
  const isMeasurementStateResolved =
    measurementEnabled ||
    !isRolloutCountry ||
    globalPrivacyControl ||
    marketingConsent === "rejected";

  useEffect(() => {
    setMetaAdsMeasurementState({
      enabled: measurementEnabled,
      isConsentResolved: isMeasurementStateResolved,
      shouldShareAllConversions,
      configuredPixelId: pixelId,
    });
    // Do not tear down here: React runs effect cleanup before consent-state updates and during
    // StrictMode replay. The next synchronized state handles explicit disablement.
  }, [isMeasurementStateResolved, measurementEnabled, pixelId, shouldShareAllConversions]);

  return null;
}
